export default __webpack_public_path__ + "static/media/cruceros.b9827b53.jpg";